<template>
  <b-card
    :class="{ 'clickable' : hasSrc }"
    :img-src="src"
    class="thumbnail">

    <span v-if="!hasSrc" class="empty">
      <i class="fas fa-file-image fa-3x"></i>
    </span>
  </b-card>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    hasSrc () {
      return this.src.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.thumbnail {
  width: 24rem;
  max-width: 100%;
  background: $light-secondary;

  .card-body {
    padding: 0 !important;
    text-align: center;

    .empty {
      line-height: 12rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/image-preview.vue